import { render } from "./StarIcon.vue?vue&type=template&id=46b06efc&scoped=true"
import script from "./StarIcon.vue?vue&type=script&lang=js"
export * from "./StarIcon.vue?vue&type=script&lang=js"

import "./StarIcon.vue?vue&type=style&index=0&id=46b06efc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b06efc"]])

export default __exports__